import React from 'react';
import { useOnboardingViewModel } from '../../view-model/onboarding/onboarding-view-model';
import { useTranslation } from 'react-i18next';

interface ReviewTutorialButtonProps {
  section: string;
  className?: string;
}

/**
 * Bouton permettant de revoir le tutoriel d'une section spécifique
 */
const ReviewTutorialButton: React.FC<ReviewTutorialButtonProps> = ({ section, className = '' }) => {
  const onboardingViewModel = useOnboardingViewModel();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const handleReviewTutorial = () => {
    // Réinitialiser l'onboarding pour cette section
    onboardingViewModel.resetSectionOnboarding(section);
    
    // Rediriger vers la page appropriée si nécessaire
    const currentPath = window.location.pathname;
    const sectionPaths: Record<string, string> = {
      dashboard: `/${currentLanguage}/provider/dashboard`,
      calendar: `/${currentLanguage}/provider/calendar`,
      reservation: `/${currentLanguage}/provider/reservation`,
      availability: `/${currentLanguage}/provider/availability`,
      services: `/${currentLanguage}/provider/services`,
      profile: `/${currentLanguage}/provider/profile`,
    };
    
    // Si nous ne sommes pas déjà sur la page de la section, rediriger
    if (sectionPaths[section] && !currentPath.includes(sectionPaths[section])) {
      window.location.href = sectionPaths[section];
    } else {
      // Sinon, recharger la page pour redémarrer le tutoriel
      window.location.reload();
    }
  };

  return (
    <button
      className={`text-primary hover:text-primary-light flex items-center justify-center rounded-full w-12 h-12 shadow-lg transition-transform hover:scale-110 bg-white dark:bg-gray-800 dark:text-white z-50 ${className}`}
      onClick={handleReviewTutorial}
      title={String(t('common.reviewTutorial'))}
      aria-label={String(t('common.reviewTutorial'))}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </button>
  );
};

export default ReviewTutorialButton;
